import React from "react";
import { toast } from "react-toastify";
import axios from "axios";

import "./style.css";
import theme from "../../../../Theme/theme";
import AddBooking from "../Modals/AddBooking";

import { API_URL, ERROR_HANDLE } from "config/constants";
import SlideSwitch from "components/SlideSwitch";
import { Constants } from "../../../../common/constants"

const SECTION_PROFILE = 0;
const SECTION_SPECIALITIES = 1;
const SECTION_VPT_PRICE_GROUP = 2;

const IMG_TRAINER_DEFAULT = require("assets/images/anal/users-anal.png");
const EDIT_ICON = require('assets/images/vpt/edit.svg')
const LABEL_DURATION = " Minutes";
const LABEL_SAVE = "Save";
const LABEL_CANCEL = "Cancel";

/**
 * An component used to render the trainer detail page.
 */
export default class TrainerDetail extends React.Component {

    state = {
        trainer: null,
        selectedSection: SECTION_PROFILE,
        profileEditable: false,
        showBookingDialog: false,
    }

    componentDidMount() {
        let trainer = this.props.location.state.trainer;
        if (!trainer.specialities) {
            trainer.specialities = []
        }
        this.setState({
            trainer
        });

        // Generate the default VPT price group
        this.defaultVPTPriceGroup = {
        };
        for (let groupKey of Constants.VPT_PRICE_GROUP_KEYS) {
            this.defaultVPTPriceGroup[groupKey] = {};
            for (let priceKey of Constants.SESSION_DURATIONS) {
                this.defaultVPTPriceGroup[groupKey][priceKey] = '';
            }
        }
    }

    renderSection = (sectionID, title) => <div className={`unselectable section label ${this.state.selectedSection == sectionID ? "section-active label-active" : ""}`} onClick={() => {
        if (this.state.selectedSection != sectionID) {
            this.setState({
                selectedSection: sectionID,
            })
            // Reset the unsaved details while switching the tab.
            if (this.state.profileEditable)
                this.resetTrainer();
        }
    }}>
        {title.toUpperCase()}
    </div>

    renderContent = (trainer) => {
        switch (this.state.selectedSection) {
            case SECTION_PROFILE:
                return this.renderProfileDetails(trainer);
            case SECTION_SPECIALITIES:
                return this.renderSpecialities(trainer);
            case SECTION_VPT_PRICE_GROUP:
                return this.renderVPTPriceGroup();
        }
    }

    uploadPic = (file, trainerId) => {
        const data = new FormData();
        data.append("image", file);
        this.apiCall(`${API_URL}/trainer/profile/image?trainerId=${trainerId}`, 'POST', data, "Uploading Image...", (error, response) => {
            if (!error) {
                window.location.reload();
            }
        });
    };

    getSpecialitiesDetails() {
        this.apiCall(`${API_URL}/trainer/specialityTiles/all?isActive=true`, 'GET', null, 'Fetching trainer specialities...', (error, response) => {
            if (!error) {
                this.setState({ specialities: response });
            }
        });
    }

    apiCall(url, method, data, loadingMsg, callback) {
        const toastId = toast(loadingMsg);
        axios({
            url,
            method: method,
            headers: {
                "x-access-token": localStorage.getItem("access_token")
            },
            data
        }).then(res => {
            callback(false, res.data);
            toast.dismiss(toastId);
        }).catch(err => {
            callback(true);
            toast.dismiss(toastId);
            ERROR_HANDLE(err);
        });
    }

    profilePicSelected = e => {
        if (e.target.files) {
            this.uploadPic(e.target.files[0], this.state.trainer.id, "cover");
        }
    };

    renderProfileImage(trainer) {
        return (
            <div className='section-image'>
                <input
                    type="file"
                    id="uploadPhoto"
                    accept="image/*"
                    name="Profile"
                    style={{ display: "none" }}
                    onChange={this.profilePicSelected}
                />
                <img className='profile-cover-image' src={trainer.profile_picture ? trainer.profile_picture : IMG_TRAINER_DEFAULT} />
                <img className='edit-image' src={EDIT_ICON} onClick={() => {
                    document.getElementById("uploadPhoto").click();
                }} />
            </div>
        )
    }

    saveTrainerActiveDetails(trainer) {
        const data = {
            is_active: trainer.is_active
        };
        this.apiCall(`${API_URL}/trainer/profile?trainerId=${trainer.id}`, 'PUT', data, "Updating Trainer Active Details...", (error, response) => {
            if (error) {
                trainer.is_active = !trainer.is_active;
                this.setState({ trainer });
            }
        });
    }

    saveTrainerDetails(trainer) {
        const data = {
            name: trainer.name,
            training_exp: trainer.training_exp,
            about: trainer.about,
            rate: trainer.rate,
            phone_number: trainer.phone_number,
            gender: trainer.gender,
            email: trainer.email,
            is_active: trainer.is_active,
            is_private: trainer.is_private
        };
        this.apiCall(`${API_URL}/trainer/profile?trainerId=${trainer.id}`, 'PUT', data, "Updating Trainer Detais...", (error, response) => {
            if (!error) {
                this.setState({
                    profileEditable: false
                });
                this.trainerCopy = null;
            }
        });
    }

    saveSpecialities = (trainer) => {
        const data = {
            specialities: trainer.specialities
        };
        this.apiCall(`${API_URL}/trainer/profile?trainerId=${trainer.id}`, 'PUT', data, "Updating Trainer Specialities...", (error, response) => {
            if (!error) {
                this.setState({
                    profileEditable: false
                });
                this.trainerCopy = null;
            }
        });
    }

    saveVPTPriceGroup = (trainer) => {
        const data = {
            vptPriceGroup: trainer.vptPriceGroup
        };
        this.apiCall(`${API_URL}/trainer/profile?trainerId=${trainer.id}`, 'PUT', data, "Updating Trainer VPT Price Group...", (error, response) => {
            if (!error) {
                this.setState({
                    profileEditable: false
                });
                this.trainerCopy = null;
            }
        });
    }

    resetTrainer() {
        if (this.trainerCopy) {
            this.setState({
                trainer: this.trainerCopy,
                profileEditable: false
            }, () => {
                this.trainerCopy = null;
            });
        }
    }

    renderProfileDetails(trainer) {
        let { profileEditable } = this.state;
        return (
            <div className='trainer-details-container'>
                {!profileEditable && <img className='edit-image' src={EDIT_ICON} onClick={() => {
                    // Deep copy the trainer object.
                    this.trainerCopy = JSON.parse(JSON.stringify(trainer));
                    this.setState({
                        profileEditable: true
                    })
                }} />}
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Name</div>
                    <input
                        className="input_TextBox trainer-details-text"
                        type='text'
                        value={trainer.name ? trainer.name : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.name = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Email</div>
                    <input
                        className="input_TextBox trainer-details-text"
                        type='email'
                        value={trainer.email ? trainer.email : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.email = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Rate($)</div>
                    <input
                        className="input_TextBox trainer-details-text"
                        type='number'
                        value={trainer.rate ? trainer.rate : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.rate = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Phone Number</div>
                    <input
                        className="input_TextBox trainer-details-text"
                        type='text'
                        value={trainer.phone_number ? trainer.phone_number : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.phone_number = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Gender</div>
                    <select
                        disabled={!profileEditable}
                        id="gender-options"
                        className="input_TextBox trainer-details-text"
                        value={trainer.gender ? trainer.gender.toLowerCase() : ''}
                        onChange={(event) => {
                            trainer.gender = event.target.value;
                            this.setState({ trainer });
                        }}>
                        <option value="" selected disabled hidden>Choose here</option>
                        <option value="male" >Male</option>
                        <option value="female" >Female</option>
                    </select>
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>Experience</div>
                    <input
                        className="input_TextBox trainer-details-text"
                        type='text'
                        value={trainer.training_exp ? trainer.training_exp : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.training_exp = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                <div className='trainer-details-row-container'>
                    <div className='trainer-details-label'>About</div>
                    <textarea
                        rows={5}
                        className="input_TextBox trainer-details-text"
                        value={trainer.about ? trainer.about : ''}
                        readOnly={!profileEditable}
                        onChange={(event) => {
                            trainer.about = event.target.value;
                            this.setState({ trainer });
                        }}
                    />
                </div>
                {profileEditable &&
                    <div className='trainer-details-row-container'>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.saveTrainerDetails(trainer);
                            }}>{LABEL_SAVE}</button>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.resetTrainer()
                            }}>{LABEL_CANCEL}</button>
                    </div>
                }
            </div>
        )
    }

    renderSpeciality = (trainer, speciality, editable) =>
        <div key={speciality.id} className="trainer-details-row-container">
            <input
                id={speciality.id}
                type="checkbox"
                name={speciality.id}
                value={speciality.id}
                disabled={!editable}
                checked={trainer.specialities.includes(speciality.id.toString())}
                className='trainer-details-checkbox'
                onChange={(e) => {
                    let id = speciality.id.toString();
                    if (e.target.checked) {
                        // Add the specialities
                        trainer.specialities.push(id);
                    } else {
                        trainer.specialities.splice(trainer.specialities.indexOf(id), 1);
                    }
                    this.setState({ trainer });
                }} />
            <label
                className='trainer-details-label'
                for={speciality.id}>
                {speciality.name}
            </label><br></br>
        </div>

    renderSpecialities(trainer) {
        let { profileEditable } = this.state;
        if (!this.state.specialities) {
            this.getSpecialitiesDetails();
            return null;
        }
        return (
            <div className='trainer-details-container'>
                {!profileEditable && <img className='edit-image' src={EDIT_ICON} onClick={() => {
                    // Deep copy the trainer object.
                    this.trainerCopy = JSON.parse(JSON.stringify(trainer));
                    this.setState({
                        profileEditable: true,
                    })
                }} />}
                {this.state.specialities.map(speciality => this.renderSpeciality(trainer, speciality, profileEditable))}
                {profileEditable &&
                    <div className='trainer-details-row-container'>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.saveSpecialities(trainer);
                            }}>{LABEL_SAVE}</button>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.resetTrainer()
                            }}>{LABEL_CANCEL}</button>
                    </div>
                }
            </div>
        )
    }

    renderPrice(groupKey, priceKey) {
        let { trainer, profileEditable } = this.state;
        return (
            <div key={groupKey + priceKey} className='trainer-details-row-container'>
                <div className='trainer-details-label'>{priceKey + LABEL_DURATION}</div>
                <input
                    className="input_TextBox trainer-details-text"
                    type='number'
                    value={trainer.vptPriceGroup[groupKey][priceKey]}
                    readOnly={!profileEditable}
                    onChange={(event) => {
                        trainer.vptPriceGroup[groupKey][priceKey] = parseFloat(event.target.value);
                        this.setState({ trainer });
                    }}
                />
            </div>
        )
    }

    renderPriceGroup(groupKey) {
        return (
            <div key={groupKey}>
                <p className='name'>{groupKey.toUpperCase()}</p>
                <div className='trainer-details-row-container'>
                    <p className='trainer-details-label'>{""}</p>
                    <p className='trainer-details-label'>{"Rate($)"}</p>
                </div>
                {Constants.SESSION_DURATIONS.map(sessionLength => {
                    return this.renderPrice(groupKey, sessionLength);
                })}
            </div>
        )
    }

    renderVPTPriceGroup() {
        let { profileEditable, trainer } = this.state;
        if (!trainer.vptPriceGroup) {
            trainer.vptPriceGroup = this.defaultVPTPriceGroup;
        }
        return (
            <div className='trainer-details-container'>
                {!profileEditable && <img className='edit-image' src={EDIT_ICON} onClick={() => {
                    // Deep copy the trainer object.
                    this.trainerCopy = JSON.parse(JSON.stringify(trainer));
                    this.setState({
                        profileEditable: true,
                    })
                }} />}
                {Constants.VPT_PRICE_GROUP_KEYS.map(groupKey => {
                    return this.renderPriceGroup(groupKey);
                })}
                {profileEditable &&
                    <div className='trainer-details-row-container'>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.saveVPTPriceGroup(trainer);
                            }}>{LABEL_SAVE}</button>
                        <button
                            className='trainer-details-button'
                            onClick={() => {
                                this.resetTrainer()
                            }}>{LABEL_CANCEL}</button>
                    </div>
                }
            </div>
        );
    }

    renderHeader(trainer) {
        return <div className='trainer-details-header-container'>
            <p className="header">Trainer {"#" + trainer.id}</p>
            <p className='name'>Active</p>
            <SlideSwitch
                checked={trainer.is_active}
                onClick={() => {
                    trainer.is_active = !trainer.is_active;
                    this.saveTrainerActiveDetails(trainer);
                    this.setState({ trainer });
                }}
            />
            <div className="unselectable" style={styles.action} onClick={() => {
                this.setState({
                    showBookingDialog: true
                })
            }}>
                Booking A Session
            </div>
        </div>
    }

    render() {
        let { trainer } = this.state
        return (
            trainer ?
                <div>
                    <div className='section-row'>
                        {this.renderProfileImage(trainer)}
                        {this.renderHeader(trainer)}
                    </div>
                    <div style={styles.root}>
                        <div className="section-container">
                            {this.renderSection(SECTION_PROFILE, "Profile")}
                            {this.renderSection(SECTION_SPECIALITIES, "Specialities")}
                            {this.renderSection(SECTION_VPT_PRICE_GROUP, "VPT Price Group")}
                        </div>
                        <div className="box">
                            <div className="content">
                                {this.renderContent(trainer)}
                            </div>
                        </div>
                    </div>
                    {
                        this.state.showBookingDialog &&
                        <AddBooking trainerEmail={trainer.email} close={() => {
                            this.setState({
                                showBookingDialog: false
                            })
                        }} />
                    }
                </div> : null
        )
    }

}

const styles = {
    root: {
        display: "flex",
        flexDirection: "column",
        padding: "10px",
    },
    button: {
        width: 100,
        height: 50
    },
    action: {
        marginTop: 30,
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 3
    }
};